import { ReactNode } from 'react';

export const ProfileAdContainer = ({ children }: { children: ReactNode }) => {
  return <div className="flex h-[300px] justify-center bg-mglGray50 pt-6 tablet:h-[250px] tablet:pt-0">{children}</div>;
};

export default {};
